import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static values = { searchUrl: String }

  connect() {
  }

  searchDate() {
    const targetMonth = document.getElementById('target_month').value
    Rails.ajax({
      url: this.searchUrlValue + `?target_month=${targetMonth}`,
      type: "GET",
      dataType: 'json',
      success: (response)=> {
      }
    });
  }

}
